import BeforeAjax from "../../BeforeAjax";
import AfterAjax from "../../AfterAjax";

export default class BeforeAfterUpdateExtension {
	initialize(naja) {
		naja.addEventListener('before', () => {
			// Inicializace před AJAXem
			BeforeAjax.defaultInitBeforeAjax();

			BeforeAjax.customInitBeforeAjaxFunctions.forEach(callback => {
				callback();
			});
		});

		naja.addEventListener('complete', (event) => {
			const payload = event.detail.payload || {}; // Defaultní hodnota pro payload

			// Inicializace po dokončení AJAXu
			AfterAjax.defaultInitOnAjax(payload);

			AfterAjax.customInitOnAjaxFunctions.forEach(callback => {
				callback(payload);
			});
		});
	}
}